import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { loadUserProfileThunk } from 'store/authentication/authentication.thunks';
import { closeMenu, openMenu } from 'store/menu/menu.slice';

import MenuIcon from '../../../assets/icons/menu.svg';
import BaarLogoTransparentPNG from '../../../assets/images/baar_logo_transparent.png';
import * as utils from '../../../shared/utils';
import { useAppDispatch, useAppSelector } from '../../../store';
import { vocabulary } from '../../../vocabulary/german';

const TopBar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const dispatch = useAppDispatch();
  const menu = useAppSelector((state) => state.menu);
  const modals = useAppSelector((state) => state.modals);
  const currentYearName = useAppSelector(
    (state) => state.years.currentYearName,
  );
  const authentication = useAppSelector((state) => state.authentication);

  const role = localStorage.getItem('role');
  const isAdmin = role === 'admin';
  const hasToken = utils.isTokenExist();

  useEffect(() => {
    dispatch(loadUserProfileThunk());
  }, [dispatch]);

  const toggleMenu = () => {
    if (menu.isOpen) {
      dispatch(closeMenu!());
    } else {
      dispatch(openMenu!());
    }
  };

  const renderTab = (name: string, key: number): JSX.Element => {
    return (
      <div className={'top-bar-tab'} key={key}>
        <p className={'top-bar-tab__text'}>{name}</p>
      </div>
    );
  };

  const renderTabForReports = (): JSX.Element => {
    const pageUrl: any = window.location.pathname.split('/').pop();

    if (pageUrl) {
      switch (pageUrl) {
        case 'short-report': {
          return (
            <div className={'top-bar-tab'}>
              <p className={'top-bar-tab__text'}>Kurz-Berichte</p>
            </div>
          );
        }
        case 'full-report': {
          return (
            <div className={'top-bar-tab'}>
              <p className={'top-bar-tab__text'}>Vollstängiger Report</p>
            </div>
          );
        }
        default: {
          return <></>;
        }
      }
    } else {
      return <></>;
    }
  };

  const toggleDropdown = () => {
    setIsExpanded(!isExpanded);
  };

  if (!hasToken) {
    return null;
  }

  return (
    <div className={'top-bar'}>
      {!!currentYearName && (
        <div className={'top-bar-left'}>
          <div className={'top-bar-icon-wrapper'}>
            <img
              className={'top-bar__menu-icon'}
              src={MenuIcon}
              alt=""
              onClick={toggleMenu}
            />
          </div>
        </div>
      )}
      <div className={'top-bar-mid'}>
        <Link to="/">
          <img
            className={'top-bar-logo'}
            src={BaarLogoTransparentPNG}
            alt="logo"
          />
        </Link>
        {!!currentYearName && (
          <div className="top-bar-mid__year">
            <span>{vocabulary.labels.yearSelections}: </span>
            <Link to="/years">{currentYearName}</Link>
          </div>
        )}
      </div>
      <div className="top-bar-right">
        <div className={'top-bar-tabs'}>
          {renderTabForReports()}
          {modals!.map(
            (modal, index) => modal.isOpen && renderTab(modal.name!, index),
          )}
        </div>
        <div className="profile-dropdown">
          <div className="profile-dropdown-toggle">
            <p className={'profile-dropdown-toggle__name'}>
              <Link to={'/profile'}>
                {authentication.user && authentication.user.username}
              </Link>
              <i
                className={classNames(
                  'profile-dropdown-toggle__icon',
                  isExpanded && 'is-active',
                )}
                onClick={() => toggleDropdown()}
              />
            </p>
          </div>
          <div
            className={classNames(
              'profile-dropdown-toggle profile-dropdown-modal',
              isAdmin && isExpanded && 'is-active',
            )}
          >
            <Link to={'/users'} onClick={() => toggleDropdown()}>
              <p className="dropdown-item">{'Users'}</p>
            </Link>
          </div>
          <div
            className={classNames(
              'profile-dropdown-toggle profile-dropdown-modal',
              isExpanded && 'is-active',
            )}
          >
            <Link to={'/logout'}>
              <p className="dropdown-item">{'Logout'}</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
